import { render, staticRenderFns } from "./tan_step.vue?vue&type=template&id=76cd2388&scoped=true"
import script from "./tan_step.vue?vue&type=script&lang=js"
export * from "./tan_step.vue?vue&type=script&lang=js"
import style0 from "./tan_step.vue?vue&type=style&index=0&id=76cd2388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd2388",
  null
  
)

export default component.exports